import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationNone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAnimationNone"><Path fillRule="evenodd" clipRule="evenodd" d="M11.25 3H21V4.5H12.75V21H3V19.5H11.25V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationNone;
